import React from 'react';
import TestResponse from '../../TestResponse/TestResponse';

const PortalTestResponse = () => {
  return <TestResponse backPath="/portal/test-management" responsePath="/portal/test-response" />;
};

export default PortalTestResponse;
